import { t } from "@/i18n-js/instance";
import type { Paywall } from "@/react/types/Paywall";
import { Badge } from "@circle-react-uikit/Badge";

interface PaywallStatusBadgeProps {
  paywall: Paywall;
}

export const PaywallStatusBadge = ({ paywall }: PaywallStatusBadgeProps) => (
  <Badge variant={paywall.status === "active" ? "success" : "default"}>
    {t(`settings.paywalls.status.${paywall.status}`)}
  </Badge>
);
